import * as sentry from './sentry'
import { Plat_isCordova } from '../../zap/Plat/Plat.device'
import { User_audioThemeGet } from '../../zap/User/User.get'

export let audioBank: any
const audioElement = document.createElement('audio')

export function getTheme() {
    if (User_audioThemeGet() != null) {
        localStorage.setItem('audio_theme', User_audioThemeGet())
        return User_audioThemeGet()
    }
    if (localStorage.getItem('audio_theme') != null) return localStorage.getItem('audio_theme')
    return 'default'
}

export function play(name: string, theme?: string) {
    try {
        if (theme == null) theme = getTheme()
        if (audioBank[theme] != null) {
            if (audioBank[theme][name] != null) {
                if (Plat_isCordova() && Media != null) {
                    const sound = new Media(
                        cordova.file.applicationDirectory + '/www/' + audioBank[theme][name],
                        () => undefined,
                        () => undefined
                    )
                    return sound.play()
                }

                audioElement.setAttribute('src', audioBank[theme][name])
                audioElement.addEventListener(
                    'load',
                    function () {
                        audioElement.play()
                    },
                    true
                )

                audioElement.play()
            }
        }
    } catch (error) {
        sentry.err(error, {})
    }
}

export function initialise() {
    audioBank = {
        default: {
            get_points: 'audio/default/get_points.mp3',
            positive: 'audio/default/positive.mp3',
            level_up: 'audio/default/level_up.mp3',
            message: 'audio/default/message.mp3',
            splash: 'audio/default/splash.mp3',
            submit: 'audio/default/submit.mp3',
            system_error: 'audio/default/system_error.mp3',
            user_error: 'audio/default/user_error.mp3',
            event: 'audio/default/event.mp3',
        },
        bright: {
            get_points: 'audio/bright/get_points.mp3',
            positive: 'audio/bright/positive.mp3',
            level_up: 'audio/bright/level_up.mp3',
            message: 'audio/bright/message.mp3',
            splash: 'audio/bright/splash.mp3',
            submit: 'audio/bright/submit.mp3',
            system_error: 'audio/bright/system_error.mp3',
            user_error: 'audio/bright/user_error.mp3',
            event: 'audio/bright/event.mp3',
        },
    }
}
